export default function LoadingSpinner({ label = 'Loading data…' }) {
  return (
    <div className="loading-spinner" role="status" aria-label={label}>
      <div className="spinner-ring" />
      <span>{label}</span>
    </div>
  );
}
